<template lang="pug">
#sideMenu
  v-container.pl-0.pb-0(fluid)
    .public-folio Folio {{publicFolio == true ? "Público" : "Privado"}}
  v-container#side.pt-0(fluid)
    v-navigation-drawer(class="lighten-3" light mobile-break-point="1100")
      v-list
        v-list-tile(v-for="section in allSections" :key="section.title" @click="$vuetify.goTo(section.go)")
          v-list-tile-content
            v-list-tile-title {{ section.title }}
</template>
<script>
export default {
  name: "Side",
  props: {},
  data() {
    return {
      sections: [
        {
          title: "Postal",
          go: "#top"
        },
        {
          title: "Datos específicos",
          go: "#specifics"
        },
        {
          title: "Notas periodísticas",
          go: "#news"
        },
        {
          title: "Ubicación en el mapa",
          go: "#location"
        }
      ]
    };
  },
  computed: {
    allSections() {
      let edit = this.$store.state.editing;
      if (edit)
        this.sections.push({
          title: "Historial de actualizaciones",
          go: "#updates"
        });
      return this.sections;
    },
    publicFolio() {
      return this.$store.state.record.public;
    }
  }
};
</script>
<style scoped lang="scss">
#sideMenu {
  position: fixed;
}
.public-folio {
  background-color: #000;
  border: none;
  color: #fff;
  font-weight: 800;
  margin: auto 3rem auto 0;
  padding: .25rem .25rem .25rem 2rem ;
}
#side {
  max-width: 15vw;
  
  .navigation-drawer {
    width: 13% !important;
    overflow-wrap: normal;
    width: 100% !important;
    .list__tile__content {
      overflow: visible !important;
      .list__tile__title {
        overflow: visible !important;
        white-space: normal !important;
        height: auto !important;
      }
    }
  }
}
</style>
